import url from 'front-end-core/core/url'
import { COMMENTS } from 'constants/controllers'
import FilterContainer from 'redux/containers/pages/comments/FilterContainer'
import React, { useEffect, useState } from 'react'
import onClickOutside from 'react-onclickoutside'

const AuthoredByFilter = ({
  users,
  category,
  order,
  privacy,
  archived,
  allUsers,
  userUrn,
  aol,
  ...props
}) => {
  const link = users => url(COMMENTS, { aol }, { category, order, users, privacy, archived })
  const shortcuts = [{ name: 'Me', value: [userUrn] }, { name: 'Show all', value: 'all' }]
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (allUsers) {
      const _options = allUsers.map(({ firstName, lastName, uri }) => ({ name: `${firstName} ${lastName}`, value: uri }))

      _options.sort((a, b) => {
        const nameA = a.name.toLowerCase()
        const nameB = b.name.toLowerCase()
        return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0
      })
      setOptions(_options)
    }
  }, [allUsers])

  AuthoredByFilter.handleClickOutside = () => {
    props.setExpanded(false)
  }

  return (
    <FilterContainer
      title='Authored by:'
      link={link}
      value={users}
      multi
      multiSuffix='users'
      {...{ ...props, options, shortcuts }}
    />
  )
}

const clickOutsideConfig = {
  handleClickOutside: () => AuthoredByFilter.handleClickOutside
}

export default onClickOutside(AuthoredByFilter, clickOutsideConfig)
